import React, { useEffect, useState } from 'react';

interface BubbleFormActions {
  goBack: () => void;
  goForward: () => void;
  goStart: () => void;
}

export interface BubbleFormPage<T> {
  key: string;
  render: (actions: BubbleFormActions, resources?: T) => React.ReactNode;
}

interface BubbleFormProps<T> {
  pages: Array<BubbleFormPage<T>>;
  resources?: T;
  startAtPage?: number;
}

export default function BubbleForm<T>(props: BubbleFormProps<T>) {
  const firstPage = 0;

  const [currentPage, setCurrentPage] = useState(-1);

  useEffect(() => {
    setCurrentPage(props.startAtPage || firstPage);
  }, [props.startAtPage]);

  function goBack() {
    setCurrentPage(Math.max(currentPage - 1, firstPage));
  }

  function goForward() {
    setCurrentPage(Math.min(currentPage + 1, props.pages.length - 1));
  }

  function goStart() {
    setCurrentPage(props.startAtPage || firstPage);
  }

  return (
    <div className="bubble-form">
      {props.pages.map((page, indx) => (
        <div key={page.key} className="form-page">
          {currentPage !== -1 &&
            currentPage === indx &&
            page.render({ goBack, goForward, goStart }, props.resources)}
        </div>
      ))}
    </div>
  );
}
